module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6MB08"))).then(() => parcelRequire('hEqeo'));